import { Skeleton } from "@/components/ui/skeleton";
import { PageShell } from "@/components/PageShell";

export function PageSkeleton({ rows = 5 }) {
  return (
    <PageShell>
      <div className="flex items-start justify-between px-4 lg:px-6">
        <div className="space-y-2">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-64" />
        </div>
        <Skeleton className="h-9 w-28" />
      </div>
      <div className="flex flex-col gap-4 px-4 lg:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <Skeleton className="h-9 w-full max-w-sm" />
          <Skeleton className="h-9 w-full max-w-xs" />
        </div>
        <div className="overflow-hidden rounded-lg border border-border">
          <div className="space-y-0 divide-y">
            {Array.from({ length: rows }).map((_, i) => (
              <div key={i} className="px-4 py-3">
                <Skeleton className="h-5 w-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageShell>
  );
}
